import { Col, Row } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { GUTTOR_SPACE } from '../../constants/commonConstants';
import { Payer } from '../../models/payer.model';
import FormMultiEmailInput from '../crmFormElement/FormMultiEmailInput/FormMultiEmailInput';
import BuddhiMedFileUpload from './buddhimedFileUpload/BuddhiMedFileUpload';
import ApplicationDetail from '../../services/applicationDetail.service';
import NonHISBuddhimedFileUpload from './buddhimedFileUpload/NonHISBuddhimedFileUpload';
import { HospitalState } from '../../../store/models/hospitalModel';
import HISBuddhimedFileUpload from './buddhimedFileUpload/HISBuddhimedFileUpload';
import { HIS_NEW_DESIGN_DOCUMENT_UPLOAD_FLOW, NON_HIS_NEW_DESIGN_DOCUMENT_UPLOAD_FLOW } from '../../constants/crmConstants';
import { documentUploadFlow, getLettersFromPatientDetails } from '../../../modules/crm/inPatient/service/crmUtils';

const QueryResponse = ({ form }: any): ReactElement => {
  const commonDetail = { form };
  const payer = useSelector((state: RootState): Payer => state?.payerList?.payer || {});
  const [selectedPayerEmails, setSelectedPayerEmails] = useState('');
  const { isOnMailPayer } = useSelector((state: RootState): Payer => state?.payerList?.payer || {});
  const isDocumentEnabledChecklist = ApplicationDetail.instance.getIsDocumentChecklistEnabled();
  const { selectedPatientDetail, hospitalSearchPatientDetails }: any = useSelector((state: RootState): HospitalState => state.hospital);
  const { claimDetails } = useSelector((state: RootState): any => state.admissionDetails);
  const isPreAuthNewDesignEnabled = ApplicationDetail?.instance?.getIsPreAuthNewDesignEnabled();
  const attachments = getLettersFromPatientDetails(selectedPatientDetail, hospitalSearchPatientDetails);
  useEffect((): any => {
    const payerData = JSON.parse(localStorage.getItem('payerConfiguration') || '{}');
    filterSelectedPayerEmails(payerData?.payers);
  }, []);

  const filterSelectedPayerEmails = (payerEmails: any = []): any => {
    const filteredPayerEmails = payerEmails.filter((pe: any): any => pe?.payerID === payer?.id);
    const { payerEmailID = '' } = filteredPayerEmails[0] || {};
    setSelectedPayerEmails(payerEmailID);
  };

  const documentFlow = documentUploadFlow(isPreAuthNewDesignEnabled, attachments, claimDetails);

  return (
    <React.Fragment>
      {
        isOnMailPayer &&
        <><Row gutter={GUTTOR_SPACE}>
          <Col className="muti-payer-config-emails-wrapper">
            <p>{`Your query will be sent to the following email`}</p>
            <p>
              {selectedPayerEmails?.length > 0 ? selectedPayerEmails : '-'}
            </p>
          </Col>
        </Row><Row gutter={GUTTOR_SPACE}>
            <FormMultiEmailInput detail={{
              ...commonDetail,
              key: 'additionalEmails',
              label: 'Additional Email IDs',
              size: 24,
              disabled: false,
              compareWithAdditionlData: selectedPayerEmails.split(','),
            }} />
          </Row></>
      }
      <Row gutter={GUTTOR_SPACE}>
        <div className={isPreAuthNewDesignEnabled ? 'HIS-query-size' : 'query-size'}>
          {
            documentFlow === HIS_NEW_DESIGN_DOCUMENT_UPLOAD_FLOW ?
              <HISBuddhimedFileUpload queryFlow={isDocumentEnabledChecklist &&
                payer?.showOtherBuddhimedFlow} form={form} /> :
              documentFlow === NON_HIS_NEW_DESIGN_DOCUMENT_UPLOAD_FLOW ?
                <NonHISBuddhimedFileUpload queryFlow={isDocumentEnabledChecklist &&
                  payer?.showOtherBuddhimedFlow} form={form} /> : <BuddhiMedFileUpload queryFlow={isDocumentEnabledChecklist &&
                  payer?.showOtherBuddhimedFlow} form={form} />
          }
        </div>
      </Row>
    </React.Fragment>
  );
};

export default QueryResponse;
